import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  IconButton,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
  Box,
} from '@mui/material';
import { Language as LanguageIcon } from '@mui/icons-material';

import flagUS from '../../assets/flag-us.png';
import flagBR from '../../assets/flag-br.png';
import flagES from '../../assets/flag-es.png';

const LanguageSelector = ({ iconOnly = false }) => {
  const { i18n } = useTranslation();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const languages = [
    { code: 'en', name: 'English', flag: flagUS },
    { code: 'pt', name: 'Português', flag: flagBR },
    { code: 'es', name: 'Español', flag: flagES },
  ];

  const currentLanguage = languages.find(lang => lang.code === i18n.language) || languages[0];

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLanguageChange = (languageCode) => {
    i18n.changeLanguage(languageCode);
    handleClose();
  };

  if (iconOnly) {
    return (
      <>
        <IconButton
          onClick={handleClick}
          size="small"
          sx={{ color: 'text.secondary' }}
        >
          <Box
            component="img"
            src={currentLanguage.flag}
            alt={currentLanguage.name}
            sx={{
              width: 24,
              height: 24,
              borderRadius: '50%',
              objectFit: 'cover',
            }}
          />
        </IconButton>
        <Menu
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          transformOrigin={{ horizontal: 'right', vertical: 'top' }}
          anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
          PaperProps={{
            sx: {
              mt: 1.5,
              minWidth: 150,
            },
          }}
        >
          {languages.map((language) => (
            <MenuItem
              key={language.code}
              selected={i18n.language === language.code}
              onClick={() => handleLanguageChange(language.code)}
            >
              <ListItemIcon>
                <Box
                  component="img"
                  src={language.flag}
                  alt={language.name}
                  sx={{
                    width: 24,
                    height: 24,
                    borderRadius: '50%',
                    objectFit: 'cover',
                  }}
                />
              </ListItemIcon>
              <ListItemText>{language.name}</ListItemText>
            </MenuItem>
          ))}
        </Menu>
      </>
    );
  }

  return (
    <>
      <IconButton
        onClick={handleClick}
        sx={{
          display: 'flex',
          gap: 1,
          px: 2,
          py: 1,
          borderRadius: 2,
          backgroundColor: 'background.paper',
          '&:hover': {
            backgroundColor: 'action.hover',
          },
        }}
      >
        <Box
          component="img"
          src={currentLanguage.flag}
          alt={currentLanguage.name}
          sx={{
            width: 24,
            height: 24,
            borderRadius: '50%',
            objectFit: 'cover',
          }}
        />
        <LanguageIcon fontSize="small" />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
        PaperProps={{
          sx: {
            mt: 1.5,
            minWidth: 150,
          },
        }}
      >
        {languages.map((language) => (
          <MenuItem
            key={language.code}
            selected={i18n.language === language.code}
            onClick={() => handleLanguageChange(language.code)}
          >
            <ListItemIcon>
              <Box
                component="img"
                src={language.flag}
                alt={language.name}
                sx={{
                  width: 24,
                  height: 24,
                  borderRadius: '50%',
                  objectFit: 'cover',
                }}
              />
            </ListItemIcon>
            <ListItemText>{language.name}</ListItemText>
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default LanguageSelector;
